import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';
const api = axios.create({ baseURL: `${BASE_URL}/api` });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('sp_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// ── Auth ─────────────────────────────────────────────────────────────────────
export const authLogin        = (u,p)    => api.post('/auth/login', {username:u,password:p});
export const authRegister     = (d)      => api.post('/auth/register', d);
export const authMe           = ()       => api.get('/auth/me');
export const authUsers        = (params) => api.get('/auth/users', {params});
export const authSearchUsers  = (q)      => api.get('/auth/users', {params:{search:q,limit:100}});
export const authUpdateUser   = (id,d)   => api.put(`/auth/users/${id}`, d);
export const authToggleActive = (id)     => api.patch(`/auth/users/${id}/toggle-active`);

// ── Profiles ──────────────────────────────────────────────────────────────────
export const getProfiles   = (p)        => api.get('/profiles', {params:p});
export const createProfile = (fd, onP)  => api.post('/profiles', fd, {
  headers: {'Content-Type':'multipart/form-data'},
  onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
});
export const getProfile    = (id)       => api.get(`/profiles/${id}`);
export const updateProfile = (id,d)     => api.put(`/profiles/${id}`, d);
export const patchStatus   = (id,s)     => api.patch(`/profiles/${id}/status`, {status:s});
export const bulkPatchStatus = (ids,s)  => api.patch('/profiles/bulk-status', {ids,status:s});
export const deleteProfile = (id)       => api.delete(`/profiles/${id}`);
export const getUsernames  = ()         => api.get('/profiles/usernames');
export const getClasses    = ()         => api.get('/profiles/classes');

export const uploadPhoto = (id, fd, onP) => api.post(`/profiles/${id}/photo`, fd, {
  headers: {'Content-Type':'multipart/form-data'},
  onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
});

export const uploadMasterImage = (id, type, file, onP) => {
  const fd = new FormData(); fd.append('image', file);
  return api.post(`/profiles/${id}/master-image?type=${type}`, fd, {
    headers: {'Content-Type':'multipart/form-data'},
    onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
  });
};

// export const uploadExcel = (file, onP) => {
//   const fd = new FormData(); fd.append('excelFile', file);
//   return api.post('/profiles/excel/upload', fd, {
//     headers: {'Content-Type':'multipart/form-data'},
//     onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
//   });
// };
export const uploadExcel = (file, schoolName, onP) => {
  const fd = new FormData();
  fd.append('excelFile', file);
  fd.append('schoolName', schoolName);
  return api.post('/profiles/excel/upload', fd, {
    headers: {'Content-Type':'multipart/form-data'},
    onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
  });
};
// ── Proxy image (avoids CORS on Hostinger static files) ──────────────────────
export const proxyImage = (photoPath) =>
  api.get('/profiles/proxy-image', {
    params: { p: photoPath },
    responseType: 'blob',
  });
export const exportExcel = (fields, profileIds) =>
  api.post('/profiles/export-excel', {fields,profileIds}, {responseType:'blob'});

// // Accepts either a files array OR a pre-built FormData (from UserDashboard bulk upload)
// export const bulkUploadPhotos = (filesOrFd, onP) => {
//   const fd = filesOrFd instanceof FormData
//     ? filesOrFd
//     : (() => { const f = new FormData(); filesOrFd.forEach(file => f.append('photos', file)); return f; })();
//   return api.post('/profiles/bulk-photos', fd, {
//     headers: {'Content-Type':'multipart/form-data'},
//     onUploadProgress: e => onP?.(Math.round(e.loaded*100/e.total)),
//   });
// };
// export const bulkUploadPhotos = (files, jobNo, onP) => {
//   const fd = new FormData();
//   fd.append('jobNo', jobNo);  // ← MUST be first, before photos
//   Array.from(files).forEach(f => fd.append('photos', f));
//   return api.post('/profiles/bulk-photos', fd, {
//     headers: { 'Content-Type': 'multipart/form-data' },
//     onUploadProgress: e => onP?.(Math.round(e.loaded * 100 / e.total)),
//   });
// };
export const bulkUploadPhotos = (files, schoolName, onP) => {
  const fd = new FormData();
  fd.append('schoolName', schoolName);
  Array.from(files).forEach(f => fd.append('photos', f));
  return api.post('/profiles/bulk-photos', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => onP?.(Math.round(e.loaded * 100 / e.total)),
  });
};

// ── Bulk signatures ──────────────────────────────────────────────────────────
// type='sign1': files array matched to profiles by filename (like bulk photos)
// type='sign2': single file + jobNo → applied to all profiles in that job
export const bulkUploadSignatures = (files, type, jobNo, onP) => {
  const fd = new FormData();
  (Array.isArray(files) ? files : [files]).forEach(f => fd.append('signatures', f));
  fd.append('type', type);
  if (jobNo) fd.append('jobNo', jobNo);
  return api.post('/profiles/bulk-signatures', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => onP?.(Math.round(e.loaded * 100 / e.total)),
  });
};

// ── Schools ───────────────────────────────────────────────────────────────────
export const getUserSchools = ()          => api.get('/schools/user');
export const getAllSchools  = ()          => api.get('/schools');
export const getSchoolById = (id)        => api.get(`/schools/${id}`);
export const addSchool     = (d)         => api.post('/schools', d);
export const updateSchool  = (id,d)      => api.put(`/schools/${id}`, d);
export const deleteSchool  = (id)        => api.delete(`/schools/${id}`);

// ── Admin ─────────────────────────────────────────────────────────────────────
export const getAdminStats   = ()           => api.get('/admin/stats');
export const downloadUserZip = (username, onProgress) =>
  api.get(`/admin/download/${username}`, {
    responseType: 'blob',
    onDownloadProgress: e => {
      if (e.total && e.total > 0) onProgress?.(Math.round(e.loaded*100/e.total));
      else onProgress?.(-1);
    },
  });
  
export const bulkDeleteProfiles = (ids) => api.delete('/profiles/bulkDelete', { data: { ids } });
export default api;

// ── Templates ─────────────────────────────────────────────────────────────────
export const getTemplates      = (username)   => api.get('/templates', username ? { params:{ username } } : {});
export const getTemplate       = (id)        => api.get(`/templates/${id}`);
export const createTemplate    = (d)         => api.post('/templates', d);
export const updateTemplate    = (id, d)     => api.put(`/templates/${id}`, d);
export const deleteTemplate    = (id)        => api.delete(`/templates/${id}`);
export const uploadTemplateBg  = (id, file, onP) => {
  const fd = new FormData(); fd.append('bg', file);
  return api.post(`/templates/${id}/background`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => onP?.(Math.round(e.loaded * 100 / e.total)),
  });
};
export const renderCardsPdf = (templateId, profileIds, jobNo, filterClass) =>
  api.post('/templates/render/pdf', { templateId, profileIds, jobNo, filterClass }, { responseType: 'blob' });

// ── Delivery ──────────────────────────────────────────────────────────────────
export const initDelivery       = (username, jobNo) => api.post('/delivery/init', { username, jobNo });
export const getDelivery        = (params)           => api.get('/delivery', { params });
export const patchDelivery      = (id, d)            => api.patch(`/delivery/${id}`, d);
export const bulkDelivery       = (ids, delivered, remarks) => api.patch('/delivery/bulk/update', { ids, delivered, remarks });
export const deliverySummary    = (params)           => api.get('/delivery/report/summary', { params });
